import { Button, ToastHelper } from '$components'
import type { CheckoutRequest, SmsCreditBundle } from '$api-client/types.gen'
import { SmsCreditsTopUpModal } from '$features/settings/components/sms/sms-credits-top-up-modal'
import { useMutation } from '@tanstack/react-query'
import { smsCreditsCheckoutMutation } from '$api-client/@tanstack/react-query.gen'
import { Fragment, useState } from 'react'

type PurchaseCreditsProps = {
  bundles: SmsCreditBundle[]
}

export function PurchaseCredits({ bundles }: PurchaseCreditsProps) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { mutate: checkout, isPending } = useMutation({
    ...smsCreditsCheckoutMutation(),
    onSuccess: (response) => {
      if (response.url) {
        window.open(response.url)
        setIsModalOpen(false)
        return
      }

      ToastHelper.error('Failed to start checkout.')
    },
    onError: () => ToastHelper.error('Failed to start checkout.'),
  })

  const handleConfirm = (credits: number) => {
    checkout({
      body: {
        credits: String(credits) as CheckoutRequest['credits'],
      },
    })
  }

  return (
    <Fragment>
      <Button
        variant="primary"
        onClick={() => setIsModalOpen(true)}
        disabled={bundles.length === 0}
      >
        Purchase Credits
      </Button>

      <SmsCreditsTopUpModal
        bundles={bundles}
        isOpen={isModalOpen}
        isLoading={isPending}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
      />
    </Fragment>
  )
}
